import { render, staticRenderFns } from "./RouteSummary.vue?vue&type=template&id=93235d08&"
import script from "./RouteSummary.vue?vue&type=script&lang=js&"
export * from "./RouteSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports